import { render } from "./ProductCounter.vue?vue&type=template&id=7b009476"
import script from "./ProductCounter.vue?vue&type=script&lang=js"
export * from "./ProductCounter.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__